// extracted by css-extract-rspack-plugin
export default {"triggerContent":"LocaleSelector-module__triggerContent__lli5v","triggerLabel":"LocaleSelector-module__triggerLabel__IDKuJ"};